import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=2c09e137&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=2c09e137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09e137",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FaqStructuredData: require('/app/components/FaqStructuredData.vue').default})
